export enum EHeaderRowExcel {
  Index = 'Index',
  DqgCode = 'dqg_code',
  Code = 'code',
  Name = 'name',
  Type = 'type',
  Group = 'group',
  Packing = 'packing',
  ActiveElement = 'active_element',
  Concentration = 'concentration',
  Route = 'route_using',
  UnitUsing = 'unit_using',
  LotNumber = 'lot_number',
  ExpireDate = 'expire_date',
  Total = 'total',
  Unit = 'unit',
  ImportPrice = 'import_price',
  Price = 'price',
  Manufacturer = 'manufacturer',
  CountryOfOrigin = 'country_of_origin'
}
